// Text
export const lettersRegex = new RegExp(/^[a-zA-Z]*$/g);
export const nonEmptyNonWhiteSpaceRegex = new RegExp(/^[A-Za-z0-9 \- .øØåÅæÆöÖ]*$/i);
export const nonEmptyNonWhiteSpaceNoNumberRegex = new RegExp(/^[A-Za-z \- .øØåÅæÆöÖ]*$/i);
export const nonEmptyNonWhiteSpaceRegexWithExclamation = new RegExp(/^[A-Za-z0-9 \- ! .øØåÅæÆöÖ]*$/i);

// Postal
export const postalCodeRegex = new RegExp(/^[0-9]{4}$/i);
export const postalDistrictRegex = new RegExp(/^[A-Za-zøØåÅæÆ -]{2,}$/i);

// Email
export const emailRegex = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

// Numbers
export const numberRegex = new RegExp(/^[0-9]+$/i);
export const norwegianOrganizationNumberRegex = /^[0-9]{9}$/i;

// Vehicle
export const licenseIPStandardsRegex = new RegExp(/^[A-ZÄÅÆÇÖØÜäü0-9]{2,}$/i);

// Date
export const splitDateStringEveryTwoNumbers = new RegExp('.{1,2}', 'g');
export const birthDateEN = /^(19|20)\d\d[- /.](0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])$/;
export const birthDateNO = /^(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d$/;